import { ChangeDetectorRef, Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { Share } from '@capacitor/share';
import { IonContent, ModalController, Platform } from '@ionic/angular';
import { PDFDocumentProxy, PdfViewerComponent } from 'ng2-pdf-viewer';
import * as FileSaver from 'file-saver';
import { Fullscreenable, FullscreenBreadcrumb, FullscreenButton, FullscreenProperty } from 'src/app/_interfaces/fullscreen';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { FullscreenService } from 'src/app/_provider/fullscreen.service';
import { TicketEmployee} from 'src/app/_provider/tickets/ticket.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';
import { BreadcumbService } from 'src/app/_provider/breadcumb.service';
import { BreadcrumbCustomOptions } from 'src/app/_template/fullscreen-modal/breadcrump-header/breadcrump-header.component';
@Component({
    selector: 'app-pdf-viewer',
    templateUrl: './pdf-viewer.page.html',
    styleUrls: ['./pdf-viewer.page.scss'],
    standalone: false
})
export class PdfViewerPage {

  public pdfSrc: string = ""
  public fileName: string = ""
  public pfdFilesystemPath: string = ""
  public isWeb: boolean = false
  public externalUrl: string = ""

  public searchOpen: boolean = false
  public isOverViewShow: boolean = null
  public isOpenAfterAnimation: boolean = false

  public pageOverViewArray: {pageNumber: number, pageHeight: number}[] = []

  public page: number = 1
  public pageRendered: number = 0

  public pdfWebHeight: number = 600

  public customBreadcrumbOptions: BreadcrumbCustomOptions = { 
    onBack: this.back.bind(this)
  }

  @ViewChild("pdfviewer", {static: false}) private pdfComponent: PdfViewerComponent;
  @ViewChild("mainPDF", {static: false}) private content: any


  constructor(
    private modalCtrl: ModalController,
    private changeDetector: ChangeDetectorRef,
    private platform: Platform,
    private ngZone: NgZone,
    public resizeManager: ResizeManagerService
  ) { }

  ngOnInit(): void {


    this.customBreadcrumbOptions.breadcrumbs = [
      { name: this.fileName }
    ]

    this.customBreadcrumbOptions.buttons = [
      {
        ionIcon: "fa-arrow-down",
        title: "Herunterladen",
        action: this.download.bind(this)
      }, 
      {
        ionIcon: "fa-open-new",
        title: "In neuem Tab öffnen",
        action: this.openExternal.bind(this)
      },
      {
        ionIcon: "fa-list",
        title: "Übersicht anzeigen",
        action: this.showOverView.bind(this)
      },
    ]

    if(this.platform.is("capacitor"))
        this.customBreadcrumbOptions.buttons.push({
          ionIcon: "fa-share",
          title: "Teilen",
          action: this.share.bind(this)
      })
  }

  ionViewDidEnter(){
    this.pdfWebHeight = this.content.el.clientHeight
    this.changeDetector.detectChanges()
  }

  public openExternal(){
    window.open(this.externalUrl, '_blank');
  }

  public afterPageRendered(e: PDFDocumentProxy){

    this.pageRendered = e._pdfInfo.numPages

    Array.from({length: this.pageRendered}).forEach((_, i) => {
      this.pageOverViewArray.push({
        pageNumber: i + 1,
        pageHeight: 100
      })
    })

    
  }

  overviewPageRendered(event: any, pageNumber: {pageNumber: number, pageHeight: number}){
    if(event.source.canvas.clientHeight == 0) return
    this.ngZone.run(() => 
      pageNumber.pageHeight = Math.round(event.source.canvas.clientHeight / 100 * (100/event.source.canvas.clientWidth *90))
    )
  }

  public async back(){
    await this.modalCtrl.dismiss()
  }
  
  public showOverView(){
    this.ngZone.run(() => {
      this.isOverViewShow = !this.isOverViewShow
      setTimeout(() => {
        if(this.isOverViewShow) this.isOpenAfterAnimation = true
        else this.isOpenAfterAnimation = false
      }, 400);
    })
  }

  public overviewOutsideClicked(){
    if(this.isOpenAfterAnimation) {
      this.ngZone.run(() => {
        this.isOverViewShow = false
        this.isOpenAfterAnimation = false
      })
    } 
  }

  public async share(){
    await Share.share({
      title: this.fileName,
      url: this.pfdFilesystemPath
    })
  }

  public async download(){
    FileSaver.saveAs(this.pdfSrc, this.fileName)
  }

}

